var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags"},_vm._l((_vm.list),function(tag){return _c('router-link',{key:tag.id,staticClass:"tag_link",attrs:{"to":("" + (tag.id))}},[_vm._v(" "+_vm._s(tag.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }